import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { DailyLegLoadsLogComponentPage } from './daily-leg-loads-log-component';
import { DailyLogPageModule } from '../../daily-log/daily-log/daily-log.module';
import { SharedModule } from '../../shared/shared.module';
import { GridModule, RowFilterModule } from '@progress/kendo-angular-grid';
import { DirectivesModule } from '../../../directives/directives.module';

@NgModule({
  declarations: [
    DailyLegLoadsLogComponentPage,
  ],
  imports: [
    DirectivesModule,
    IonicPageModule.forChild(DailyLegLoadsLogComponentPage),
    DailyLogPageModule,
    SharedModule,
    GridModule,
    SharedModule,
    RowFilterModule
  ],
  exports: [
    DailyLegLoadsLogComponentPage
  ]
})
export class DailyLegLoadsLogComponentPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/daily-leg-loads/daily-leg-loads-log-component/daily-leg-loads-log-component.module.ts